module.exports = __webpack_public_path__ + "img/amara-avatar.63d692be.png";